import PaypalLink from './PaypalLink';
export default PaypalLink;
